<template>
  <div class="admin">
    <template v-if="userState == 3">
      <nav class="navbar is-danger" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <a class="navbar-item" href="/">
            <img src="@/assets/img/logo.svg">
          </a>
        </div>
      </nav>
      <router-view/>
    </template>
    <template v-else-if="userState == 2">
      <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box">
            <h1 class="title is-3">Login</h1>
            <form @submit.prevent="login">
              <div class="field">
                <div class="control">
                  <label for="" class="label">Email</label>
                  <input type="text" class="input" v-model="loginEmail">
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label for="" class="label">Password</label>
                  <input type="password" class="input" v-model="loginPassword">
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <button class="button is-danger">Login</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="userState == 1">
      <div class="admin-loader">
        <div class="loader is-size-1 admin-loader__loader"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { auth } from '@/firebase.js'

export default {
  data() {
    return {
      userState: 1,
      loginEmail: null,
      loginPassword: null
    }
  },
  methods: {
    login() {
      auth.signInWithEmailAndPassword(this.loginEmail, this.loginPassword)
    }
  },
  created() {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.userState = 3
      } else {
        this.userState = 2
      }
    })
  },
  head: {
    title: {
      inner: 'Admin'
    },
    link: [
      { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.1/css/bulma.css' },
    ]
  }
}
</script>

<style lang="scss">
.file-uploader {
  display: none !important;
  &.shown {
    display: block !important;
  }
}
.admin-loader {
  position: relative;
  height: 100vh;
}
.admin-loader__loader {
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.admin__image {
  background: rgb(230,230,230);
}
</style>
